'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'scroll';
var width = 576;
var height = 512;
var aliases = [128220];
var unicode = 'f70e';
var svgPathData = 'M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48-64 0 0-48zM153.3 80L360 80c22.1 0 40 17.9 40 40l0 184-120 0c-30.9 0-56 25.1-56 56l0 40c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-288c0-11.4-2.4-22.2-6.7-32zM448 304l0-184c0-48.6-39.4-88-88-88L80 32C35.8 32 0 67.8 0 112l0 48c0 26.5 21.5 48 48 48l64 0 0 192c0 44.2 35.8 80 80 80l264 0c48.6 0 88-39.4 88-88l0-32c0-30.9-25.1-56-56-56l-40 0zm8 128l-190.7 0c4.3-9.8 6.7-20.6 6.7-32l0-40c0-4.4 3.6-8 8-8l208 0c4.4 0 8 3.6 8 8l0 32c0 22.1-17.9 40-40 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faScroll = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;